export const CONSENT_COOKIE_CATEGORIES = {
  ESSENTIAL: 'ESSENTIAL',
  NON_ESSENTIAL: 'NON_ESSENTIAL',
  FACE_REC: 'FACE_REC',
};
